module.exports = __webpack_public_path__ + "03c481c003b9f2e2d80720458c3a01b9.svg";